import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchExpenseBudgetAll = createAsyncThunk(
	"fetchExpenseBudgetAll",
	async ({ page, limit, keyword = "" }) => {
		const params = new URLSearchParams({
			page: page ?? 1,
			limit: limit ?? 10,
			keyword: keyword ?? "",
		});
		const response = await axiosHttp.get(`expense/budget/all?${params}`);
		return response.data.data;
	}
);

const ExpenseBudgetSlice = createSlice({
	name: "ExpenseBudgetSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		pagination: {
			current: 1,
			pageSize: 10,
			total: 0,
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchExpenseBudgetAll.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchExpenseBudgetAll.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			if (action.payload?.pagination) {
				state.pagination = {
					current: action.payload.pagination.current,
					pageSize: action.payload.pagination.pageSize,
					total: action.payload.pagination.total,
				};
			}
		});
		builder.addCase(fetchExpenseBudgetAll.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ExpenseBudgetSlice.reducer;
